import { useQuery, useMutation } from "@apollo/client";
import { login } from "./interface";
import { LOGIN } from "./mutation";


export function Login() {
    const [login,{data}] = useMutation<login>(LOGIN,{context: {clientName: "pre-login"}})
    return {login,data}
}
export {}